// docs-modal-delegated.js
(() => {
    const modal   = document.getElementById('doc-modal');
    if (!modal) return;

    const dialog  = modal.querySelector('.doc-modal__dialog');
    const closeBtn= modal.querySelector('.doc-modal__close');

    let lastFocus = null;

    const getFocusables = () =>
        Array.from(modal.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])'))
            .filter(el => !el.hasAttribute('disabled'));

    const open = () => {
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.classList.add('is-locked');
        (getFocusables()[0] || dialog).focus({ preventScroll: true });
    };

    const close = () => {
        modal.hidden = true;
        document.body.classList.remove('is-locked');
        lastFocus?.focus({ preventScroll: true });
    };

    // 1) DELEGACJA KLIKÓW – zatrzymujemy przejście na inną stronę
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.product-card__button');
        if (!trigger) return;

        // Jeśli to <a>, zablokuj nawigację; jeśli to <button type="submit">, zablokuj submit
        e.preventDefault();
        e.stopPropagation();
        open();
    });

    // 2) Obsługa klawiatury na triggerze (Enter/Spacja dla <a> itp.)
    document.addEventListener('keydown', (e) => {
        const trigger = e.target.closest('.product-card__button');
        if (!trigger) return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open();
        }
    });

    // 3) Zamknięcie
    closeBtn.addEventListener('click', close);
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });

    // 4) ESC + focus trap
    document.addEventListener('keydown', (e) => {
        if (modal.hidden) return;

        if (e.key === 'Escape') { e.stopPropagation(); close(); }

        if (e.key === 'Tab') {
            const f = getFocusables(); if (!f.length) return;
            const first = f[0], last = f[f.length - 1];
            if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
            else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
        }
    });
})();
